export const logosAssureurs =[
  {
    "logoTitle": "Daparentis",
    "logoUrl": "assurepro/deparentis.png"
  },
  {
    "logoTitle": "Dakar Sacre Cœur",
    "logoUrl": "assurepro/dakar-sacre-coeur-nouveau-logo.jpg"
  },
  {
    "logoTitle": "All Africa Goal",
    "logoUrl": "assurepro/allafrica.jpeg"
  },
  {
    "logoTitle": "FKS FOODS",
    "logoUrl": "assurepro/food-fks.jpeg"
  },
  {
    "logoTitle": "HPD",
    "logoUrl": "assurepro/hpd.png"
  },
  {
    "logoTitle": "ibisa",
    "logoUrl": "assurepro/ibisa.jpg"
  },
  {
    "logoTitle": "Leden Group",
    "logoUrl": "assurepro/leden-group.gif"
  },
  {
    "logoTitle": "sopasen",
    "logoUrl": "assurepro/sopasen.jpeg"
  },
  {
    "logoTitle": "wic",
    "logoUrl": "assurepro/wic.png"
  },
  {
    "logoTitle": "sonacos",
    "logoUrl": "assurepro/sonacos.jpg"
  },
  {
    "logoTitle": "ecosen",
    "logoUrl": "assurepro/ecosen.png"
  },
  {
    "logoTitle": "adresse",
    "logoUrl": "assurepro/adresse.png"
  },
   {
    "logoTitle": "taarih",
    "logoUrl": "assurepro/taarih.jpg"
  },
   {
    "logoTitle": "mbaye-mobility",
    "logoUrl": "assurepro/mbaye_mobility.jpeg"
  },
  {
    "logoTitle": "asecna-logo",
    "logoUrl": "assurepro/asecna-logo.webp"
  },
  {
    "logoTitle": "baamtu-logo",
    "logoUrl": "assurepro/baamtu_logo.jpeg"
  },
  {
    "logoTitle": "sagam-electronic",
    "logoUrl": "assurepro/sagam_electronic.png"
  },
  {
    "logoTitle": "chargel",
    "logoUrl": "assurepro/chargel.png"
  },
  {
    "logoTitle": "sagam-sec",
    "logoUrl": "assurepro/sagam-sec.png"
  },
  {
    "logoTitle": "samalife",
    "logoUrl": "assurepro/samalife.jpg"
  }
]
